<template>
  <div v-if="messages.length" class="alertes-extrapolation">
    <div v-for="(m, i) in messages" :key="i" class="bilan-alerte" :class="{ 'bilan-alerte--forte': m.fort }">
      <span v-if="m.fort">⚠ </span>{{ m.texte }}
    </div>
  </div>
</template>

<script>
import { messagesExtrapolation } from '@/utils/extrapolation'

/**
 * Avertissements sur les données de consommation extrapolées, affichés au-dessus de la courbe de la Step 3 et en tête
 * du rapport (12/10/2026). `stats` : bilan de la courbe renvoyé par le serveur (warnings, calculatedPointsPercent).
 */
export default {
  name: 'AlerteExtrapolation',
  props: {
    stats: { type: Object, default: null },
  },
  computed: {
    messages() {
      return messagesExtrapolation(this.stats)
    },
  },
}
</script>

<style scoped>
.bilan-alerte {
  margin: 12px 0;
  padding: 10px 14px;
  border-left: 4px solid #f5a623;
  background: #fff8e8;
  color: #6b4a00;
  font-size: 13px;
  border-radius: 4px;
}
.bilan-alerte--forte {
  border-left-width: 6px;
  border-left-color: #e65100;
  background: #fff0e0;
  color: #7a2e00;
  font-size: 14px;
  font-weight: 600;
}
</style>
